export default "__VITE_ASSET__e76e3cdf__"